import React, {useEffect} from 'react';
import {Image, LoadingSection, Section} from "../fusion-ui";
// import Image404 from "../assets/images/not_found_404.webp";
import {isBoolTrue} from "../fusion-ui/utils/ReactUtils";


//https://codepen.io/sarazond/pen/jOKyjZ
//https://codepen.io/rafaelavlucas/pen/NWWQNjZ
//https://gosnippets.com/snippets/custom-404-error-page-design-using-htms-css-snippet
const InvalidPanel = React.memo(({
                                     wrapperClassName = "",
                                     imgClassName = "",
                                     labelClassName = "",
                                     imgWidth = '200px',
                                     imgHeight = 'auto',
                                     borderless = true,
                                     image,
                                     wrapperStyle = {},
                                     imgStyle = {},

                                     height,
                                     color,
                                     success,
                                     loading,
                                     showLoadingCircle,
                                     show404Image,
                                     errorCode,
                                     msg = '',

                                     ...rest
                                 }) => {
    const TAG = "InvalidPanel";

    useEffect(() => {

    }, []);
    const CodeImages = {
        // '404': 'https://cdn.pixabay.com/photo/2016/04/24/13/24/error-1349562_1280.png',
        '404': 'https://cdn.pixabay.com/photo/2017/03/09/12/31/error-2129569_1280.jpg',
        '500': 'https://cdn.pixabay.com/photo/2018/01/04/15/51/404-error-3060993_1280.png',
        oops: 'https://cdn.pixabay.com/photo/2022/05/02/16/15/oops-7169963_1280.png',
        // oops: 'https://cdn.pixabay.com/photo/2018/01/04/15/51/404-error-3060993_1280.png',
        sorry: 'https://cdn.pixabay.com/photo/2016/10/06/19/59/sign-1719892_1280.png',
        sorryEmoji: 'https://cdn.pixabay.com/photo/2020/04/22/18/22/excuse-me-5079442_1280.jpg',
        sorryBoard: 'https://cdn.pixabay.com/photo/2016/02/08/17/43/sorry-1186962_1280.jpg',
    };

    return (<>
            {(isBoolTrue(loading) || !isBoolTrue(success)) &&
                <Section className={`p-3 h-autox ${wrapperClassName}`}
                         borderless={borderless} height={height}>
                    <div className={'row jc-center w-100 bg-infox al-center'}>
                        {(isBoolTrue(show404Image) && !isBoolTrue(loading) && !isBoolTrue(success)) &&
                            <Image
                                wrapperClassName={'w-100 h-100 bg-dangerx al-center jc-center mb-3'}
                                className={`${imgClassName} rounded-3`}
                                // src={getDefStr(image, getDefStr(getJsonValue(CodeImages, errorCode), Image404))}
                                src={getImg()}
                                disableDrag={true}
                                width={imgWidth}
                                height={imgHeight}
                                style={{
                                    // mixBlendMode: 'color-burn',
                                    // mixBlendMode: 'darken',
                                    // mixBlendMode: 'lighten',
                                    // mixBlendMode: 'difference',
                                    // mixBlendMode: 'exclusion',
                                    // mixBlendMode: 'overlay',
                                    // mixBlendMode: 'screen',
                                    // mixBlendMode: 'multiply',
                                    // filter: `grayscale(100%)`,
                                    // backgroundColor: 'red',
                                }}
                                // wrapperStyle={{minHeight: height}}
                            />}

                        <LoadingSection
                            className={'mt-n3'}
                            labelClassName={`m-2x w-100 fs-normal ${labelClassName}`}
                            heightClass={75}
                            color={color}
                            success={success}
                            loading={loading}
                            msg={msg}
                            showLoadingCircle={showLoadingCircle}
                            {...rest}
                        />
                    </div>
                </Section>}
        </>
    )

    function getImg() {
        // let img = getDefStr(image, getDefStr(getJsonValue(CodeImages, errorCode), Image404));
        let img;
        const message = (msg + '').toLowerCase().trim();
        if (message.includes('internal') || message.includes('invalid')) {
            img = CodeImages.oops;
        } else if (message.includes('404') || message.includes('not found') || message.includes("not available")) {
            img = CodeImages['404'];
        } else if (message.includes('500')) {
            img = CodeImages['500'];
        } else {
            img = CodeImages.sorry;
        }
        return img;
    }
});
export default InvalidPanel;
